<div class="wrapper">
  @if (this.state === "new") {
    <app-resp-popup-title i18n="@@FormularEditorArtikelNewRowPopupTitle">
      Add New Item
    </app-resp-popup-title>
  } @else {
    <app-resp-popup-title i18n="@@FormularEditorArtikelEditRowPopupTitle">
      Edit Item
    </app-resp-popup-title>
  }

  <app-resp-popup-content>
    <form [formGroup]="form">
      <div class="inputs-container">
        <div id="input-kurztext">
          <frm-text
            formControlName="descr"
            [label]="'Artikelbezeichnung'"
          ></frm-text>
        </div>
        <div id="input-menge container">
          <div class="row">
            <div class="col-sm-8">
              <frm-text formControlName="amount" [label]="'Anzahl'"></frm-text>
            </div>
            <div class="col-sm-4">
              <frm-dropdown
                formControlName="units"
                [label]="'Einheit'"
                [items]="einheiten"
              ></frm-dropdown>
            </div>
          </div>
        </div>
        <div id="input-aktion">
          <frm-dropdown
            formControlName="action"
            [label]="'Aktion'"
            [items]="actionItems"
          ></frm-dropdown>
        </div>
      </div>
    </form>
  </app-resp-popup-content>
  <app-resp-popup-actions>
    <ng-container>
      <ctrl-btn-accept (click)="onAccept()"></ctrl-btn-accept>
    </ng-container>
    <ng-container>
      <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
    </ng-container>
  </app-resp-popup-actions>
</div>
